import { cn } from "../utils";

function Skeleton({ className, ...props }: React.HTMLAttributes<HTMLDivElement>) {
	return (
		<div className={cn("relative overflow-hidden rounded-md bg-muted", className)} {...props}>
			<div className="absolute inset-0 animate-shimmer bg-gradient-to-r from-transparent via-white/10 to-transparent" />
		</div>
	);
}

export { Skeleton };
export { LoadingSkeleton, type LoadingSkeletonProps } from "./LoadingSkeleton";
